import {
  Link,
  useNavigate,
  useParams,
  useLoaderData,
} from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Select from "react-select";

import * as API from "../services/pacientes";
import * as APIESPECIALISTAS from "../services/especialistas";

import { CitaUpdate } from "./CitaUpdate";
import { CitaDelete } from "./CitaDelete";

import { Who5Delete } from "./Who5Delete";
import { Scl90Delete } from "./Scl90Delete";
import { PsqiDelete } from "./PsqiDelete";
import { NotificacionDelete } from "./NotificacionDelete";

export function CitaEdit(props) {
  const cita = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = cita.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [citaResp, setCitaResp] = useState(cita.meta?.citaResp);
  const [citaTipo, setCitaTipo] = useState(cita.meta?.citaTipo);
  const [citaPac, setCitaPac] = useState(cita.meta?.citaPac);
  const [citaFecha, setCitaFecha] = useState(cita.meta?.citaFecha);
  const [citaHora, setCitaHora] = useState(cita.meta?.citaHora);
  const [citaFinFecha, setCitaFinFecha] = useState(cita.meta?.citaFinFecha);
  const [citaFinHora, setCitaFinHora] = useState(cita.meta?.citaFinHora);
  const [citaObs, setCitaObs] = useState(cita.meta?.citaObs);

  const [pacienteId, setPacienteId] = useState(cita.meta?.citaPacId);
  console.log(pacienteId);
  let citaId = cita.id;

  const citaDate = new Date(cita.date);
  const diffDate = (Math.abs(new Date() - citaDate) / 36e5);

  const [loading, setLoading] = useState(false);
  const [pacienteQuery, setPacienteQuery] = useState("");
  const [pacienteList, setPacienteList] = useState();
  const [pacienteSelect, setPacienteSelect] = useState([]);
  const [especialistaQuery, setEspecialistaQuery] = useState("");
  const [especialistaList, setEspecialistaList] = useState();
  const [especialistaSelect, setEspecialistaSelect] = useState([]);
  const [citaEsp, setCitaEsp] = useState(cita.meta?.citaEsp);

  const [citaTipoFirstRender, setCitaTipoFirstRender] = useState(true);
  const isFirstRender = useRef(true);


// 1. Get list of users by input query set in React Select
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      if (props.userRole.includes('administrador')) {
        await API.getSearchPacientes(pacienteQuery).then(
          (val) => {
            setPacienteList(val);
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        await API.getSearchPacientesByEspecialista(pacienteQuery, props.especialistaId).then(
          (val) => {
            setPacienteList(val);
            console.log(val)
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  fetchData();
}, [pacienteQuery]);

// 2. Map all Pacientes to create the options for React Select
useEffect(() => {
  let pacienteSelect;
  if (pacienteList) {
    pacienteSelect = pacienteList?.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setPacienteSelect(pacienteSelect);
  }
}, [pacienteList]);

// 3. Get ID value of Paciente Selected
useEffect(() => {
  if (citaPac) {
    setPacienteId(citaPac?.value);
  }
}, [citaPac]);

  // 4. Get list of especialistas by input query set in React Select
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (props.userRole.includes('administrador')) {
          await APIESPECIALISTAS.getSearchEspecialistasAndAdmins(especialistaQuery).then(
            (val) => {
              setEspecialistaList(val);
              console.log(val);
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };

    fetchData();
  }, [especialistaQuery]);

  // 5. Map all Especialistas to create the options for React Select
  useEffect(() => {
    let especialistaSelect;
    if (especialistaList) {
        especialistaSelect = especialistaList?.map((field) => ({
          value: field.id,
          label: field.display_name,
        }));
      }
    setEspecialistaSelect(especialistaSelect);
  }, [especialistaList]);

  // 7. Clean values on update tipo de cita
  useEffect(() => {
    if (!isFirstRender.current) {
      if (citaTipo !== 'ingreso' && citaTipo !== 'refuerzo') {
        setCitaFinFecha('');
        setCitaFinHora('');
      }
      if (citaTipo === 'nota') {
        setPacienteId(0);
        setCitaPac("");
      }
    } else {
      isFirstRender.current = false;
    }
  }, [citaTipo]);

  useEffect(() => {
    setCitaTipoFirstRender(false);
  }, []);


  const submitCita = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(citaResp, citaTipo, citaPac, citaFecha, citaHora, citaFinFecha, citaFinHora, citaObs, pacienteId, citaId, citaEsp);
    try {
      await CitaUpdate( 
        citaResp, citaTipo, citaPac, citaFecha, citaHora, citaFinFecha, citaFinHora, citaObs, pacienteId, citaId, citaEsp
       ).then(
        (val) => {
          navigate(`../${cita.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
  
    try {
      // Check citaTipo and delete related records conditionally
      if (cita.meta?.citaTipo === 'who5' && cita.meta?.citaPostId) {
        await Who5Delete(cita.meta?.citaPostId);
        console.log(`Deleted who5 Post: ${cita.meta?.citaPostId}`);
      } else if (cita.meta?.citaTipo === 'scl90' && cita.meta?.citaPostId) {
        await Scl90Delete(cita.meta?.citaPostId);
        console.log(`Deleted scl90 Post: ${cita.meta?.citaPostId}`);
      } else if (cita.meta?.citaTipo === 'psqi' && cita.meta?.citaPostId) {
        await PsqiDelete(cita.meta?.citaPostId);
        console.log(`Deleted psqi Post: ${cita.meta?.citaPostId}`);
      }
  
      // Delete citaNotificacionId if it exists
      if (cita.meta?.citaNotificacionId) {
        await NotificacionDelete(cita.meta?.citaNotificacionId);
        console.log(`Deleted citaNotificacionId: ${cita.meta?.citaNotificacionId}`);
      }
  
      // Delete the main cita object
      await CitaDelete(citaId).then(
        (val) => {
          window.location.replace("../../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    } finally {
      setIsDeletingButton(false);
    }
  };
  

  return (
    <>
    <div id="content">
      {cita?.length === 0 ? (
        <div>Cargando...</div>
      ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
      <form id="formUpdatelement" onSubmit={submitCita}>
        <fieldset id="disabledContainer">
          <div className='grid--2col'>

            <div className='field'>
              <label htmlFor='citaResp'>Responsable</label>
              {props.userRole.includes('administrador') ? (
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaEsp'
                  name='citaEsp'
                  required
                  isLoading={loading}
                  options={especialistaSelect}
                  value={citaEsp}
                  placeholder='Seleccionar Especialista'
                  onInputChange={setEspecialistaQuery}
                  onChange={setCitaEsp}
                />
              </div>
              ) : (
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaEsp'
                  name='citaEsp'
                  required
                  isLoading={loading}
                  options={especialistaSelect}
                  value={citaEsp}
                  placeholder='Seleccionar Especialista'
                  onInputChange={setEspecialistaQuery}
                  onChange={setCitaEsp}
                />
              </div>
              )}
            </div>

            <div className='field'>
              <label htmlFor='citaTipo'>Tipo de Cita</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='citaTipo'
                    name='citaTipo'
                    required
                    value={citaTipo}
                    onChange={(e) => setCitaTipo(e.target.value)}
                  >
                    {( props.userRole.includes('administrador')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='ingreso'>Ingreso</option>
                      <option value='valoracion'>Valoracion</option>
                      <option value='refuerzo'>Refuerzo</option>
                      <option value='consulta-pre-tratamiento-medica'>Consulta Pre-Tratamiento Médica</option>
                      <option value='consulta-post-tratamiento-medica'>Consulta Post-Tratamiento Médica</option>
                      <option value='consulta-pre-tratamiento-psicologica'>Consulta Pre-Tratamiento Psicológica</option>
                      <option value='consulta-post-tratamiento-psicologica'>Consulta Post-Tratamiento Psicológica</option>
                      <option value='psicoterapia'>Sesión Psicoterapia</option>
                      <option value='nutricion'>Nutrición</option>
                      <option value='entrenamiento'>Entrenamiento</option>
                      <option value='mindfulness'>Mindfulness</option>
                      <option value='nota'>Nota</option>
                      <option value='who5'>Test Who5</option>
                      <option value='psqi'>Test PSQI</option>
                      <option value='scl90'>Test SCL90</option>
                    </>
                    : ( props.userRole.includes('medicina')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='consulta-pre-tratamiento-medica'>Consulta Pre-Tratamiento Médica</option>
                      <option value='consulta-post-tratamiento-medica'>Consulta Post-Tratamiento Médica</option>
                    </>
                    : ( props.userRole.includes('psicologia')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='consulta-pre-tratamiento-psicologica'>Consulta Pre-Tratamiento Psicológica</option>
                      <option value='consulta-post-tratamiento-psicologica'>Consulta Post-Tratamiento Psicológica</option>
                      <option value='psicoterapia'>Sesión Psicoterapia</option>
                    </>
                    : ( props.userRole.includes('nutricion')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='nutricion'>Nutrición</option>
                    </>
                    : ( props.userRole.includes('entrenamiento')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='entrenamiento'>Entrenamiento</option>
                    </>
                    : ( props.userRole.includes('mindfulness')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='mindfulness'>Mindfulness</option>
                    </>
                    :
                      <option disabled value=''>Sin Permisos</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>

          {(citaTipo !== 'nota') &&

          <div className='field'>
              <label htmlFor='citaPac'>Paciente</label>
              <div className='control'>
                <Select
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaPac'
                  name='citaPac'
                  required
                  isLoading={loading}
                  options={pacienteSelect}
                  value={citaPac}
                  placeholder='Seleccionar Paciente'
                  onInputChange={setPacienteQuery}
                  onChange={setCitaPac}
                />
              </div>
            </div>

          }

          <div className='grid--2col'>  
            <div className='field'>
              <label htmlFor='citaFecha'>Fecha Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFecha'
                  required
                  type='date'
                  value={citaFecha}
                  onChange={(e) => setCitaFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaHora'>Hora Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaHora'
                  required
                  type='time'
                  value={citaHora}
                  onChange={(e) => setCitaHora(e.target.value)}
                />
              </div>
            </div>

            {((citaTipo === 'ingreso') || (citaTipo === 'refuerzo')) &&
            <>
            <div className='field'>
              <label htmlFor='citaFinFecha'>Fecha Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinFecha'
                  required
                  type='date'
                  value={citaFinFecha}
                  onChange={(e) => setCitaFinFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaFinHora'>Hora Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinHora'
                  required
                  type='time'
                  value={citaFinHora}
                  onChange={(e) => setCitaFinHora(e.target.value)}
                />
              </div>
            </div>
            </>
            }
          </div>
          <div className='field'>
            <label htmlFor='citaObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='citaObs'
                id='citaObs'
                value={citaObs}
                onChange={(e) => setCitaObs(e.target.value)}
              ></textarea>
            </div>
          </div>

      </fieldset>
      </form>
      ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
        {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        }
      <Link className="button is-link is-light" to={`../${cita.id}`}>Cancelar</Link>
      {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}